import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {DuluxEventTypes} from "./Events";

export enum DuluxEventContainerTypes {
    Journeys = "da970a6d-721e-4a98-bb38-785f0a5e475d",
    BlueStoreLeads = "794ea5e2-86a8-4ffa-bf93-78af3afa09ba",
}

export const duluxEventContainerTypeByEventType: Record<DuluxEventTypes, DuluxEventContainerTypes> = {
    [DuluxEventTypes.Enquiry]: DuluxEventContainerTypes.Journeys,
    [DuluxEventTypes.Onboarding]: DuluxEventContainerTypes.Journeys,
    [DuluxEventTypes.Calls]: DuluxEventContainerTypes.Journeys,
    [DuluxEventTypes.Leads]: DuluxEventContainerTypes.Journeys,
    [DuluxEventTypes.Appointments]: DuluxEventContainerTypes.Journeys,
    [DuluxEventTypes.BlueStoreEnquiries]: DuluxEventContainerTypes.BlueStoreLeads,
    [DuluxEventTypes.BlueStoreCalls]: DuluxEventContainerTypes.BlueStoreLeads,
    [DuluxEventTypes.BlueStoreWalkins]: DuluxEventContainerTypes.BlueStoreLeads,
    [DuluxEventTypes.BlueStoreRfh]: DuluxEventContainerTypes.BlueStoreLeads,
    [DuluxEventTypes.BlueStoreRfq]: DuluxEventContainerTypes.BlueStoreLeads,
    [DuluxEventTypes.BlueStoreQuotations]: DuluxEventContainerTypes.BlueStoreLeads,
    [DuluxEventTypes.BlueStoreCustomQuotations]: DuluxEventContainerTypes.BlueStoreLeads,
};

// Stable migration IDs for direct tooling/debugging. Runtime code resolves these columns from template configuration.
export const DULUX__EVENT_CONTAINER__AID_LEADS__DISPOSITION__COLUMN_ID = "e3931809-0a92-40b9-b4b4-2d50d621abc9" as Uuid;

export const DULUX__EVENT_CONTAINER__AID_LEADS__ORGANIZATIONAL_UNIT__COLUMN_ID = "54e96418-ab62-4fb0-ab6f-21b31ea300ac" as Uuid;

export const DULUX__EVENT_CONTAINER__BLUE_STORE_LEADS__DISPOSITION__COLUMN_ID = "1ee555da-748c-4ef8-b2a7-cb9b48c7685c" as Uuid;

export const DULUX__EVENT_CONTAINER__BLUE_STORE_LEADS__ORGANIZATIONAL_UNIT__COLUMN_ID = "fdc9abc6-0bff-405f-8125-f2e66e7717d2" as Uuid;

export const DULUX__EVENT_CONTAINER__NAME__COLUMN_ID = "51d9f75e-43c6-43c7-891c-5ce829d0ea84" as Uuid;

export const DULUX__EVENT_CONTAINER__CONTACT_NUMBER__COLUMN_ID = "e3a73323-c1f2-4ab8-acff-f0c5e3989b7f" as Uuid;

export const DULUX__EVENT_CONTAINER__EMAIL__COLUMN_ID = "10198ff6-24cc-49e5-91ac-793a99609dd0" as Uuid;

export const DULUX__EVENT_CONTAINER__ASSIGNED_TO__COLUMN_ID = "31d30225-efb5-4d8b-abf9-132f4e1681fa" as Uuid;

export const DULUX__EVENT_CONTAINER__LEAD_STATUS__COLUMN_ID = "0a2930c2-0c51-46b1-afea-15cd5ac423bb" as Uuid;

export const DULUX__EVENT_CONTAINER__ASSIGNED_ON__COLUMN_ID = "eaa11756-5484-45c5-8221-7a0f2a421575" as Uuid;

export const DULUX__EVENT_CONTAINER__LAST_EVENT_TIMESTAMP__COLUMN_ID = "df327fac-5007-46a9-948e-06000452180c" as Uuid;

export const DULUX__EVENT_CONTAINER__LAST_EVENT__COLUMN_ID = "6d2f52c9-84ab-4390-8fbb-423c09dc8002" as Uuid;

export const DULUX__EVENT_CONTAINER__REMARKS__COLUMN_ID = "c52dd342-a115-4a0f-aa52-1bf8e1409cbe" as Uuid;

export const DULUX__EVENT_CONTAINER__BLUE_STORE_LEADS__REMARKS__COLUMN_ID = "6d335a9c-1d63-4044-8e00-e17afcf2df07" as Uuid;

export const DULUX__EVENT_CONTAINER__PLATFORM__COLUMN_ID = "ebb62b26-23a1-4937-8469-67b451609be0" as Uuid;

export const DULUX__EVENT_CONTAINER__SOURCE__COLUMN_ID = "d487e6f7-69a5-4893-8849-dd3c88d307b7" as Uuid;

export const DULUX__EVENT_CONTAINER__COMPANY_NAME__COLUMN_ID = "45378906-41bf-4abb-bd26-dd11b2802256" as Uuid;

export const DULUX__EVENT_CONTAINER__PINCODE__COLUMN_ID = "a33c45f2-6bfd-4660-8f59-cb5bd752a91e" as Uuid;

export const DULUX__EVENT_CONTAINER__STATE__COLUMN_ID = "da40ea60-3208-46fd-ac44-0f17b873be8b" as Uuid;

export const DULUX__EVENT_CONTAINER__CITY__COLUMN_ID = "fe5e6687-9119-46c3-865c-9316f3c51c5b" as Uuid;

export const DULUX__EVENT_CONTAINER__SCHEDULED_CALL_DATE__COLUMN_ID = "f09920a3-59fc-459e-ac54-b3ae5d775dbf" as Uuid;

export const DULUX__EVENT_CONTAINER__SCHEDULED_CALL_TIME__COLUMN_ID = "f473a2c9-5630-46a4-a22c-cee447d8c983" as Uuid;

export const DULUX__EVENT_CONTAINER__ENQUIRY_COUNT__COLUMN_ID = "be4e1894-0459-4a1c-88d6-13f4e731e8ca" as Uuid;

export const DULUX__EVENT_CONTAINER__CALL_LOG_COUNT__COLUMN_ID = "f62ce585-1a28-4bfe-ad9c-562da40c9329" as Uuid;

export const DULUX__EVENT_CONTAINER__APPOINTMENT_COUNT__COLUMN_ID = "7b2a1e49-0f9a-4431-ae01-7ca7739fa291" as Uuid;

export const DULUX__EVENT_CONTAINER__ONBOARDING_COUNT__COLUMN_ID = "82c32342-8126-4290-af3e-f4c66a05389e" as Uuid;

export enum EventContainerDispositionEnum {
    NOT_CONNECTED_NC1,
    NOT_CONNECTED_NC2,
    NOT_CONNECTED_NC3,
    NOT_CONNECTED_NC4,
    NOT_CONNECTED_NC5,
    NOT_CONNECTED_NC6,
    CONNECTED_VALID_INTERESTED_APPOINTMENT_GIVEN,
    CONNECTED_VALID_INTERESTED_AID_ONBOARDED,
    CONNECTED_VALID_INTERESTED_GENERAL_INFORMATION_REQUIRED,
    CONNECTED_VALID_INTERESTED_AID_KIT_NEEDED_NON_SERVICEABLE_AREA,
    CONNECTED_VALID_INTERESTED_OTHER,
    CONNECTED_VALID_INTERESTED_MORE_MEETINGS_REQUIRED,
    CONNECTED_VALID_NOT_INTERESTED_NON_SERVICEABLE_AREA,
    CONNECTED_VALID_NOT_INTERESTED_NOT_AN_AID,
    CONNECTED_CALL_BACK_LATER_CBL1,
    CONNECTED_CALL_BACK_LATER_CBL2,
    CONNECTED_CALL_BACK_LATER_CBL3,
    CONNECTED_INVALID_DID_NOT_FILL,
    CONNECTED_INVALID_FILLED_BY_MISTAKE,
    WRONG_NUMBER,
}

export enum DuluxLeadStatusEnum {
    // CONVERTED = "68583a1d-742a-4873-9888-34451d89efe8",
    CHURNED = "d9e06c2c-3727-4876-86d3-3d57b51f1972",
    OPEN_LEAD = "e8f01e60-ca1c-4ba7-8363-7474808d5898",
    AID_ONBOARDED = "c9f77718-0f19-4bff-93ab-8535c8bd1de8",
    ARCHIVED = "8d2732d2-6224-4347-9565-2ae4d67f7ce0",
}

export const eventContainerDispositions: Record<EventContainerDispositionEnum, {
    id: Uuid,
    displayName: string,
    flatDisposition:string
}> = {
    [EventContainerDispositionEnum.NOT_CONNECTED_NC1]: {
        id: "ff884228-1244-4ae5-ba59-5a8540fd7ff2" as Uuid,
        displayName: "Not connected nc1",
        flatDisposition: "not-connected_nc1"
    },
    [EventContainerDispositionEnum.NOT_CONNECTED_NC2]: {
        id: "db1d806a-85da-43b3-a00c-a29f45ca2c55" as Uuid,
        displayName: "Not connected nc2",
        flatDisposition: "not-connected_nc2"
    },
    [EventContainerDispositionEnum.NOT_CONNECTED_NC3]: {
        id: "7b96a4e4-aff6-4141-826a-d25332e1daf8" as Uuid,
        displayName: "Not connected nc3",
        flatDisposition: "not-connected_nc3"
    },
    [EventContainerDispositionEnum.NOT_CONNECTED_NC4]: {
        id: "a27642e6-7f21-49e6-8734-a5592d04d2a3" as Uuid,
        displayName: "Not connected nc4",
        flatDisposition: "not-connected_nc4"
    },
    [EventContainerDispositionEnum.NOT_CONNECTED_NC5]: {
        id: "af3e82c0-3902-457a-92be-513e507a608b" as Uuid,
        displayName: "Not connected nc5",
        flatDisposition: "not-connected_nc5"
    },
    [EventContainerDispositionEnum.NOT_CONNECTED_NC6]: {
        id: "6f45b784-08ec-4613-81c0-a66c61528ac8" as Uuid,
        displayName: "Not connected nc6",
        flatDisposition: "not-connected_nc6"
    },
    [EventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_APPOINTMENT_GIVEN]: {
        id: "d0eff4ff-067b-4dc9-baa1-830233fafdc0" as Uuid,
        displayName: "Connected valid interested appointment given",
        flatDisposition: "connected_valid_interested_appointment-given"
    },
    [EventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_AID_ONBOARDED]: {
        id: "9bfeb58e-9495-4aa8-b4ce-a796d9cbdfdb" as Uuid,
        displayName: "Connected valid interested aid onboarded",
        flatDisposition: "connected_valid_interested_aid-onboarded"
    },
    [EventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_GENERAL_INFORMATION_REQUIRED]: {
        id: "369bf252-b8ea-4437-9ed2-ea62870fc516" as Uuid,
        displayName: "Connected valid interested general information required",
        flatDisposition: "connected_valid_interested_general-information-required"
    },
    [EventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_AID_KIT_NEEDED_NON_SERVICEABLE_AREA]: {
        id: "d963c620-08a6-45cf-a0ff-478b643f9423" as Uuid,
        displayName: "Connected valid interested aid kit needed non serviceable area",
        flatDisposition: "connected_valid_interested_aid-kit-needed-non-serviceable-area"
    },
    [EventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_OTHER]: {
        id: "32cc5a8e-e023-4a6b-b934-c0f555f59b88" as Uuid,
        displayName: "Connected valid interested other",
        flatDisposition: "connected_valid_interested_other"
    },
    [EventContainerDispositionEnum.CONNECTED_VALID_INTERESTED_MORE_MEETINGS_REQUIRED]: {
        id: "a4fb9bb1-311b-43e3-9e7d-8448de4b8bdc" as Uuid,
        displayName: "Connected valid interested more meetings required",
        flatDisposition: "connected_valid_interested_more-meetings-required"
    },
    [EventContainerDispositionEnum.CONNECTED_VALID_NOT_INTERESTED_NON_SERVICEABLE_AREA]: {
        id: "2da7711d-ec17-4d1a-b172-0d18a9436cbc" as Uuid,
        displayName: "Connected valid not interested non serviceable area",
        flatDisposition: "connected_valid_not-interested_non-serviceable-area"
    },
    [EventContainerDispositionEnum.CONNECTED_VALID_NOT_INTERESTED_NOT_AN_AID]: {
        id: "12cb5be0-f050-45b2-bcc4-cfe94c4f012f" as Uuid,
        displayName: "Connected valid not interested not an aid",
        flatDisposition: "connected_valid_not-interested_not-an-aid"
    },
    [EventContainerDispositionEnum.CONNECTED_CALL_BACK_LATER_CBL1]: {
        id: "a721c86b-8ba1-46c7-9db2-fd0bfca418aa" as Uuid,
        displayName: "Connected call back later cbl1",
        flatDisposition: "connected_call-back-later_cbl1"
    },
    [EventContainerDispositionEnum.CONNECTED_CALL_BACK_LATER_CBL2]: {
        id: "7014619a-d817-4f31-b5a2-8e2f75ad79bc" as Uuid,
        displayName: "Connected call back later cbl2",
        flatDisposition: "connected_call-back-later_cbl2"
    },
    [EventContainerDispositionEnum.CONNECTED_CALL_BACK_LATER_CBL3]: {
        id: "d81cda8e-1684-4a5e-a17e-370a196e575a" as Uuid,
        displayName: "Connected call back later cbl3",
        flatDisposition: "connected_call-back-later_cbl3"
    },
    [EventContainerDispositionEnum.CONNECTED_INVALID_DID_NOT_FILL]: {
        id: "07445438-5dfb-4f47-a3ba-cf05134c60aa" as Uuid,
        displayName: "Connected invalid did not fill",
        flatDisposition: "connected_invalid_did-not-fill"
    },
    [EventContainerDispositionEnum.CONNECTED_INVALID_FILLED_BY_MISTAKE]: {
        id: "800726e6-0c5a-4306-96fb-b39ef736121b" as Uuid,
        displayName: "Connected invalid filled by mistake",
        flatDisposition: "connected_invalid_filled-by-mistake"
    },
    [EventContainerDispositionEnum.WRONG_NUMBER]: {
        id: "cf6ab1a7-8374-4166-96a4-b3a40aa72959" as Uuid,
        displayName: "Wrong number",
        flatDisposition: "wrong-number"
    },
};

export function getDuluxEventContainerDispositions(): Array<{id: Uuid; displayName: string}> {
    return Object.values(eventContainerDispositions).map((disposition) => ({
        id: disposition.id,
        displayName: disposition.displayName,
    }));
}

/** Journey module / hierarchical selector — `displayName` is the underscore-separated flat slug (L1–L4). */
export function getDuluxEventContainerDispositionsForModule(): Array<{id: Uuid; displayName: string}> {
    return Object.values(eventContainerDispositions).map((disposition) => ({
        id: disposition.id,
        displayName: disposition.flatDisposition,
    }));
}

export enum LeadEnquiryTypeEnum {
    HOT = "7925d05d-e7d5-4faa-b48f-cad9ea7fd347",
    WARM = "5439cafa-3504-498a-b503-6e9ddc8c917f",
    COLD = "9b5434a5-9e74-4ee7-bff8-3f360ce93dd5",
}

export const leadStatuses: Record<DuluxLeadStatusEnum, {
    id: Uuid,
    displayName: string
}> = {
    // [DuluxLeadStatusEnum.CONVERTED]: {
    //     id: "68583a1d-742a-4873-9888-34451d89efe8" as Uuid,
    //     displayName: "Converted"
    // },
    [DuluxLeadStatusEnum.CHURNED]: {
        id: DuluxLeadStatusEnum.CHURNED as Uuid,
        displayName: "Churned"
    },
    [DuluxLeadStatusEnum.OPEN_LEAD]: {
        id: DuluxLeadStatusEnum.OPEN_LEAD as Uuid,
        displayName: "Open Lead"
    },
    [DuluxLeadStatusEnum.AID_ONBOARDED]: {
        id: DuluxLeadStatusEnum.AID_ONBOARDED as Uuid,
        displayName: "Aid Onboarded"
    },
    [DuluxLeadStatusEnum.ARCHIVED]: {
        id: DuluxLeadStatusEnum.ARCHIVED as Uuid,
        displayName: "Archived"
    },
};

export const leadEnquiryTypes: Record<LeadEnquiryTypeEnum, {
    id: Uuid,
    displayName: string
}> = {
    [LeadEnquiryTypeEnum.HOT]: {
        id: "7925d05d-e7d5-4faa-b48f-cad9ea7fd347" as Uuid,
        displayName: "Hot"
    },
    [LeadEnquiryTypeEnum.WARM]: {
        id: "5439cafa-3504-498a-b503-6e9ddc8c917f" as Uuid,
        displayName: "Warm"
    },
    [LeadEnquiryTypeEnum.COLD]: {
        id: "9b5434a5-9e74-4ee7-bff8-3f360ce93dd5" as Uuid,
        displayName: "Cold"
    },
};
